var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"article-status",style:('background-color: ' + _vm.color + ';')})
}
var staticRenderFns = []

export { render, staticRenderFns }